/** @jsx jsx */
import { jsx } from '@emotion/core';
import { memo } from 'react';
import CachingEmoji from '../common/CachingEmoji';
import { emojiItem, emojiPickerRow } from './styles';

const EmojiPickerEmojiRow = ({
  emojis,
  onSelected,
  onMouseMove,
  title,
  showDelete,
  onDelete
}) => jsx("div", {
  css: emojiPickerRow
}, emojis.map(emoji => {
  const {
    shortName,
    id
  } = emoji;
  const key = id ? `${id}-${title}` : `${shortName}-${title}`;
  return jsx("span", {
    css: emojiItem,
    key: key
  }, jsx(CachingEmoji, {
    emoji: emoji,
    selectOnHover: true,
    onSelected: onSelected,
    onMouseMove: onMouseMove,
    showDelete: showDelete,
    onDelete: onDelete,
    placeholderSize: 24,
    shouldBeInteractive: true
  }));
}));

export default /*#__PURE__*/memo(EmojiPickerEmojiRow);